var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"title":"Cash","hideUserDropdown":!_vm.user,"id":"header"}}),(_vm.validatingToken)?_c('Loading'):_c('Content'),_c('Footer'),_c('LGPDModal'),(_vm.user && _vm.user.tipoUsuario >= 1)?_c('LGPDSuporteModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }